// src/event-handlers-modules.ts
function EventDefinition(type, isDomainEvent = false, _transformations = {}) {
  return () => ({
    __type: "event-definition",
    type,
    isDomainEvent,
    transformations: _transformations
  });
}
export {
  EventDefinition
};
